<template>
  <div onpaste="return false">
                    

    <w-loading-spinner :loadSpinner="loading" />
    <div class="col login-card-div" v-if="!showForgotPasswordScreen">
      <div class="card card-layout" style="top:0px !important;">
        <!-- <w-text-input
          v-if="!resetTab"
          class="text-left login-fields mt-5 font-weight-bold m-0 m-auto"
          :labelName="'Username'"
          :className="'bold'"
          @textInputChange="getUsername($event)"
          validation="required"
          :maxCharacter="'150'"
        />-->
        <p class="text-left login-fields mt-3 font-weight-bold m-0 m-auto heading-message"
         style="font-size:22px !important;">
          Hi
          <span v-if="!branchActivate">{{ username }}</span>
          <span v-else>{{ branchUsername }}</span>, Please Enter the Following:
        </p>
        <div>
          <p class="text-left login-fields mt-1 font-weight-bold mb-0 m-auto">New Password</p>
          <b-form-group class="lato-regular login-fields mt-1 " :label="''">
            <b-form-input
              v-model="password"
              :type="passwordType"
              name="Password"
              v-validate="'required|regex_password'"
              :state="errors.has('Password') ? false : null"
              ref="password"
              class="width-control-password lato-regular-input m-0 m-auto"
            ></b-form-input>
            <div :class="eyeStatus">
              <img @click="showPassword()" :src="imgSrc(eyeStatus)" />
            </div>
            <div
              :class="
                'helo-block mt-1 alert alert-danger errorWidth errormsg-credential'
              "
              v-show="errors.has('Password')"
            >{{ errors.first("Password") }}</div>
          </b-form-group>
          <p class="text-left login-fields mt-3 font-weight-bold mb-0 m-auto">Confirm New Password</p>
          <b-form-group class="lato-regular login-fields mt-1" :label="''">
            <b-form-input
              v-model="confirmPassword"
              :type="confirmPasswordType"
              name="Confirm Password"
              :state="errors.has('Confirm Password') ? false : null"
              v-validate="{ required: true, confirmed: password }"
              class="width-control-password lato-regular-input m-0 m-auto"
            ></b-form-input>
            <span :class="confirmEyeStatus">
              <img @click="confirmShowPassword()" :src="confirmImgSrc(confirmEyeStatus)" />
            </span>

            <div
              :class="
                'helo-block mt-1 alert alert-danger errorWidth errormsg-credential'
              "
              v-show="errors.has('Confirm Password')"
            >{{ errors.first("Confirm Password") }}</div>
          </b-form-group>
        </div>

        <div>
          <p class="text-left login-fields font-weight-bold mt-3 m-auto">OTP</p>
          <b-form-input
            v-model="otpForReset"
            :type="'number'"
            @keypress="validateInput($event)"
            @keyup="validateInput($event)"
            class="OTP mb-4"
          ></b-form-input>

          <div style="background-color: #ffe9a5;
    font-size: 12px;
    padding: 10px;
    text-align: center;
    color: #0b4600;padding: 5px 5px;margin: 5px 40px;">
         Note: {{smsSuccessMessage}}.It is valid for 5 mins. Kindly wait before trying resend OTP.
      </div>
      <div style="
    background: #e9f2f9;
    margin: 5px 40px;
    padding: 5px;
    font-size: 12px;color:#353a58;
">
*For Indian mobile numbers, Kindly ensure you have not opted <b>Do Not Disturb [DND]</b> 
option.To opt-out from Do Not Disturb [DND] List, SMS <b style="color:red;">START</b> to 
<b style="color:red;">9790864100</b> 
From Registered Mobile and will get Confirmation SMS instantly
</div>
          <button
            class="float-right mr-5 pr-2 resend mt-2"
            :disabled="disableResendOTPButton"
            @click="resendOTP()"
          >Resend OTP {{disableResendOTPButton && countdown > -1 && countdown < 61 ? '('+countdown+')' : ''}}</button>
        </div>
        <!-- <b-button 
          v-if="!resetTab"
          class="openSans-regular home-button reset-btn-size mt-2 mb-2"
          @click="resetPassword()"
          :disabled="!username"
        >Reset Password</b-button>-->
        <b-button
          :disabled="checkUserField()"
          class="openSans-regular submit-btn-size mt-2 mb-2"
          @click="sendOTP()"
        >Submit</b-button>

        <div v-if="!branchActivate" style="padding: 10px 25px;font-size: 16px;">
          <span class="lato-regular cursor-pointer"
          style="width: 50%;text-align: left;display: inline;padding: 5px 30px;float: left;"
          @click="goHome()">
    Go To Home</span>
  <span class="lato-regular cursor-pointer"
  style="width: 50%;text-align: right;display: inline;padding: 5px 30px;float: left;"
   @click="goToLogin()">
  Login Instead?</span></div>
      </div>
    </div>
    <!-- <b-modal
      v-model="resetSuccess"
      :ok-title="'Go To Login Page'"
      @ok="navigateToPage()"
      id="reset-success"
      title="Success"
    >
      <p class="my-4">Successfully Changed the Password</p>
    </b-modal>-->
    <!-- <b-modal
      v-model="resetFailure"
      id="res-error-email"
      :ok-title="'Retry'"
      title="Failed to Reset Password!"
    >
      <p class="my-4">Please Enter Correct OTP and Try Again</p>
    </b-modal>-->
    <w-modal
      :trigger="resetSuccess"
      :id="'success-login'"
      :title="'Success'"
      :text="'Successfully Changed the Password!'"
      :okTitle="'Go To Login Page'"
      :okOnly="true"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      @eventOk="navigateToPage()"
    />

    <w-modal
      :trigger="resetFailure"
      :id="'failure-login'"
      :title="'Failure!'"
      :text="'Please Enter Correct OTP and Try Again'"
      :okTitle="'Try again!'"
      :okOnly="true"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      @eventOk="reloadPage()"
    />

    <w-modal
      :trigger="usernameCheckFailed"
      :id="'username-unavailable'"
      :title="'Failed!'"
      :text="'Invalid Username, please enter correct Username!'"
      :okTitle="'Try again!'"
      :okOnly="true"
      :centered="true"
      :dontCloseWhenClickedOutside="false"
      :dontCloseWhenEscapePressed="false"
      :dontShowCloseIcon="false"
      @eventOk="changeUsernameStatus()"
    />

    <w-modal
      :trigger="emailNotVerified"
      :id="'email-not-verified'"
      :title="'Failed!'"
      :text="'Email not Verified!, Please verify to Reset your password!'"
      :okTitle="'Try again!'"
      :okOnly="true"
      :centered="true"
      :dontCloseWhenClickedOutside="false"
      :dontCloseWhenEscapePressed="false"
      :dontShowCloseIcon="false"
      @eventOk="changeEmailModalStatus()"
    />
    <widgetModal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertsuccess"
      :showSuccess="successModal"
      @eventClose="handleModel()"
    />

    <b-toast id="my-toast" variant="primary" toaster="b-toaster-top-center">
      <template v-slot:toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">
          <strong class="mr-auto source-sans-pro bold">OTP Reset</strong>
        </div>
      </template>
      <span class="source-sans-pro bold">{{otpToastResponse}}</span>
      <!-- <b-alert>Alert example</b-alert> -->
    </b-toast>
    <!-- <b-alert v-if="otpModalEnable">{{otpToastResponse}}</b-alert> -->
    <b-modal
      id="modal1"
      v-model="otpModalEnable"
      title
      ok-only
      no-close-on-backdrop
      no-close-on-esc
      @ok="handleRedirectLoginOk()"
      @close="handleRedirectLoginOk()"
    >
      <p class="m-4">{{otpToastResponse}}</p>
    </b-modal>
  </div>
</template>

<script>
import TextInput from "../widgets/TextInput";
import Modal from "../widgets/ModalWidget";
import widgetModal from "../widgets/newModalWidget";
import LoadingSpinner from "../widgets/LoadingSpinner";
import { ResetPasswordService } from "../services/ResetPasswordService.js";
const ResetService = new ResetPasswordService();


export default {
  components: {
    "w-text-input": TextInput,
    "w-modal": Modal,
    widgetModal,
    "w-loading-spinner": LoadingSpinner
  },
  data() {
    return {
      smsSuccessMessage: "OTP has been sent to registered email.",
      email: '',
      mobile: '',
      disableResendOTPButton: false,
      username: null,
      otpForReset: null,
      password: "",
      confirmPassword: "",
      resetTab: false,
      resetSuccess: false,
      resetFailure: false,
      passwordMatch: true,
      usernameCheckFailed: false,
      lastResponse: "",
      emailNotVerified: false,
      triggerModal: false,
      alertsuccess: false,
      successModal: false,
      branchActivate: false,
      loading: false,
      email: "",
      eyeStatus: "hiddenPassword",
      confirmEyeStatus: "ConfrimhiddenPassword",
      passwordType: "password",
      confirmPasswordType: "password",
      dummyOtp: "",
      branchUsername: "",
      otpModalEnable: false,
      otpToastResponse: "",
      countdown: 60,
      int1:'',
      int2:''
    }; 
  },
  watch: {
    confirmPassword: function(newVal, oldVal) {
      this.matchPasswords();
    }
  },
  created() {
    // if (this.$router.currentRoute.name == "ResetPassword") {
    //   this.goToLogin();
    // }
    
      var self = this
      this.disableResendOTPButton = true;
      this.countdown=60
      this.int2 = setInterval(function(){self.countdown = self.countdown-1},1000)
    setTimeout(() => {
      this.disableResendOTPButton = false;
      clearInterval(self.int2)
      clearInterval(self.int1)
    }, 60000);
    if (this.$route.query.email) {
      this.branchActivate = true;
      this.email = this.$route.query.email;
      var loginName = decodeURIComponent(this.$route.query.user);
      this.branchUsername = this.DecodeUsingAES(this.$route.query.user);
      if (this.branchUsername) {
        ResetService.getEmailMobile(loginName)
          .then(res => {
            if (res.response.maxAudit == "N") {
              var mobileNumber = this.DecodeUsingAES(res.response.mobileNumber);
              var firstTwo = mobileNumber.substring(0, 2);
              var firstSeven = firstTwo.concat("*****");
              var starsMobile = firstSeven.concat(
                mobileNumber.substring(7, 10)
              );
              ResetService.getOtpTrigger(this.branchUsername).then(res => {
                var otpMessage =
                  "One Time Password(OTP) has been sent to Registered Email and Mobile " +
                  starsMobile +
                  " To set Password";
                this.otpToastResponse = otpMessage;
                this.$bvToast.show("my-toast");
              });
            } else {
              this.otpToastResponse =
                "Your Account is already Activated. Please Login.";
              this.otpModalEnable = true;
              // this.$router.push("/login");
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
      // alert(this.branchUsername);

      //this.username = this.DecodeUsingAES(this.$route.query.email);
      this.username = this.$route.query.user;
      // alert(this.branchActivate)
      // this.branchActivate = true;
      return;
    }

    if (this.$route.params.mobile) {
      this.mobile = this.$route.params.mobile;
    } 
    if (this.$route.params.email) {
      this.email = this.$route.params.email;
    } 
    if (this.$route.params.message) {
      this.smsSuccessMessage = this.$route.params.message
    }
    if (this.$route.params.userName) {
      this.username = this.$route.params.userName;
    } else {
      this.goToLogin();
    }
  },
  methods: {
    handleRedirectLoginOk() {
      this.$router.push("/login");
    },
    imgSrc(icon) {
      if (this.eyeStatus == "showPassword") {
        icon = "showPassword";
        var images = require.context("@/assets/images/", false, /\.svg$/);
        return images("./" + icon + ".svg");
      } else if (this.eyeStatus == "hiddenPassword") {
        icon = "hiddenPassword";
        var images = require.context("@/assets/images/", false, /\.svg$/);
        return images("./" + icon + ".svg");
      }
    },
    confirmImgSrc(icon) {
      if (this.confirmEyeStatus == "ConfrimshowPassword") {
        icon = "ConfrimshowPassword";
        var images = require.context("@/assets/images/", false, /\.svg$/);
        return images("./" + icon + ".svg");
      } else if (this.confirmEyeStatus == "ConfrimhiddenPassword") {
        icon = "ConfrimhiddenPassword";
        var images = require.context("@/assets/images/", false, /\.svg$/);
        return images("./" + icon + ".svg");
      }
    },
    showPassword() {
      if (this.eyeStatus === "hiddenPassword") {
        this.passwordType = "text";
        this.eyeStatus = "showPassword";
      } else {
        this.passwordType = "password";
        this.eyeStatus = "hiddenPassword";
      }
    },
    checkUserField() {
      if (
        this.password &&
        this.confirmPassword &&
        this.errors.items.length == 0 &&
        this.dummyOtp.length == 6
      ) {
        return false;
      } else {
        return true;
      }
      // (this.password == null &&
      //   this.confirmPassword != null &&
      //   errors.items.length == 0 &&
      //   otpForReset.length == 6) ||
      //   (this.password == "" || this.confirmPassword == "") ||
      //   this.passwordMatch;
    },
    confirmShowPassword() {
      if (this.confirmEyeStatus === "ConfrimhiddenPassword") {
        this.confirmPasswordType = "text";
        this.confirmEyeStatus = "ConfrimshowPassword";
      } else {
        this.confirmPasswordType = "password";
        this.confirmEyeStatus = "ConfrimhiddenPassword";
      }
    },
    getUsername(event) {
      this.username = event;
    },
    goToLogin() {
      this.$router.push("/login");
    },
    goHome() {
      this.$router.push("/");
    },
    validateInput(event) {
      if (event.target.value.length >= 6) {
        this.dummyOtp = event.target.value;
        event.preventDefault();
        return false;
      } else {
        this.dummyOtp = event.target.value;
      }
    },
    handleModel() {
      this.triggerModal = false;
      if (this.successModal == true) {
        this.successModal = false;
        this.goToLogin();
      }
      if (this.lastResponse == "Otp Expired") {
        this.resetTab = false;
        this.alertsuccess = false;
      }
      this.alertsuccess = false;
    },
    // resetPassword() {
    //   ResetService.requestResetPassword(this.username).then(res => {
    //     if (res.response == "Sms sent successfully") {
    //       this.resetTab = true;
    //     }
    //     if (res.status == "FAILURE") {
    //       this.triggerModal = true;
    //       this.alertsuccess = true;
    //       this.lastResponse = res.failureMessage;
    //     }
    //   });
    // },
    sendOTP() {
      let otp = this.otpForReset.toString();
      let newPassword = this.password.toString();
      if (this.branchActivate == false) {
        // alert(this.branchActivate);
        var submitForm = {
          passwordResetToken: this.otpForReset.toString(),
          userName: this.EncodeUsingAES(this.username),
          password: this.EncodeUsingAES(newPassword)
        };
        this.loading = true;
        ResetService.sendOTPforReset(submitForm).then(res => {
          this.loading = false;
          if (res.status == "SUCCESS") {
            this.triggerModal = true;
            this.successModal = true;
            this.lastResponse = res.response;
          } else {
            this.triggerModal = true;
            this.alertsuccess = true;
            this.lastResponse = res.failureMessage;
          }
        });
      } else {
        var branchForm = {
          passwordResetToken: this.otpForReset.toString(),
          emailId: this.email,
          userName: this.username,
          password: this.EncodeUsingAES(newPassword)
        };
        this.loading = true;
        ResetService.sendOTPforBranchActivate(branchForm).then(res => {
          this.loading = false;
          if (res.status == "SUCCESS") {
            this.triggerModal = true;
            this.successModal = true;
            this.lastResponse = res.response;
          } else {
            this.triggerModal = true;
            this.alertsuccess = true;
            this.lastResponse = res.failureMessage;
          }
        });
      }
    },
    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_K)
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return encrypted.toString();
      }
    },
    DecodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        try {
          value = value.split(" ").join("+");
          const keys = atob(process.env.VUE_APP_E_K)
          const key = CryptoJS.enc.Utf8.parse(keys);
          const vectorIV = CryptoJS.enc.Utf8.parse(keys);
          const decrypted = CryptoJS.AES.decrypt(value, key, {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });
          return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (e) {
          throw e;
        }
      }
    },

    navigateToPage() {
      this.goToLogin();
    },
    reloadPage() {
      this.$router.go(this.$router.currentRoute);
    },
    getPassword(event) {
      this.password = event;
    },
    changeUsernameStatus() {
      this.usernameCheckFailed = false;
    },
    changeEmailModalStatus() {
      this.emailNotVerified = false;
    },
    matchPasswords() {
      if (this.password === this.confirmPassword) {
        this.passwordMatch = false;
      } else {
        this.passwordMatch = true;
      }
    },
    resendOTP() {
      var self = this
      this.disableResendOTPButton = true;
      this.countdown=60
      this.int1 = setInterval(function(){self.countdown = self.countdown-1},1000)
      setTimeout(() => {
        this.disableResendOTPButton = false;
      clearInterval(self.int2)
      clearInterval(self.int1)
      }, 60000);
      var smscode = 2;
      if (this.branchActivate == true) {
        var loginName = this.username;
      } else {
        var loginName = this.EncodeUsingAES(this.username);
      }
      ResetService.resendOTP(loginName, smscode).then(res => {
        if (res) {
          // this.form.otp = res.response.otp;
        }
      });
    }
  }
};
</script>

<style scoped>
.hiddenPassword {
  float: right;
  margin-top: -30px;
  margin-right: 3%;
}
.showPassword {
  float: right;
  margin-top: -30px;
  margin-right: 3%;
}
.ConfrimhiddenPassword {
  float: right;
  margin-top: -30px;
  margin-right: 3%;
}
.ConfrimshowPassword {
  float: right;
  margin-top: -30px;
  margin-right: 3%;
}
.login-img {
  /* background: url("../assets/images/login_image.jpg"); */
  background-size: cover;
  height: 100vh;
}
.login-card-div {
  background-color: #f0f4f7;
  height: 100vh;
}
.card-layout {
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  width: 30vw;
  height: auto;
  position: relative;
  top: 10vh;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.login-fields {
  font-family: "Source Sans Pro", sans-serif;
  width: 80%;
  margin: auto;
}
.reset-btn-size {
  width: 50%;
  margin: 0 auto;
  background-color: #002d72 !important;
  color: white !important;
}
.submit-btn-size {
  width: 40%;
  margin: 0 auto;
  background-color: #002d72 !important;
  color: white !important;
  cursor: pointer;
}
.submit-btn-size:disabled {
  cursor: not-allowed;
}
.forgot-password {
  cursor: pointer;
  width: fit-content;
  margin: 0 0 0 auto;
  text-align: right;
  padding-right: 10%;
  font-size: 18px;
  font-weight: normal;
  color: #002d72;
}
.go-home {
  position: relative;
  top: 15vh;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 20px;
  font-weight: 600;
  color: #002d72;
  width: fit-content;
  cursor: pointer;
}
.OTP {
  margin: auto;
  width: 80%;
}
.errorWidthSmall {
  width: 80%;
  margin: auto;
}
.heading-message {
  font-size: 25px;
  font-weight: 600;
}
.resend {
  font-family: "Titillium Web", sans-serif;
  letter-spacing: 0.96px;
  font-size: 15px;
  color: #0843a8;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

[disabled="disabled"]{opacity: 0.5;pointer-events: none;}
</style>
